import React from 'react';
import { ISectionWrapper } from '@belong/types';
import { Section } from '@belong/ui-components/components/styles';
import { getTemplateView } from './templates';
import { ISectionSupportArticle } from './model';

export const TEST_ID = {
  CONTAINER: 'section-support-article'
};

const SECTION_STYLES: ISectionWrapper = {
  hasPaddingTop: true,
  hasPaddingBottom: true,
  hasBackground: 'white'
};

const SectionSupportArticle: React.FunctionComponent<ISectionSupportArticle> = props => {
  const Layout = getTemplateView(props.template.contentType);

  return (
    <Section data-contentid={props.id} data-testid={TEST_ID.CONTAINER} {...SECTION_STYLES}>
      <Layout {...props} />
    </Section>
  );
};

export default SectionSupportArticle;
